module.exports = __webpack_public_path__ + "static/media/Pannor_Shop-small.f96bede6.jpg";